































































































































































import BaseComponent from '@/components/base-component.vue';
import CancellationReasons from '@/components/parameters/cancellation-reasons/list.vue';
import ParametersFormBlockingIanctiveAccess from '@/components/parameters/form/blocking-inactive-access.vue';
import ParametersFormExpirationTime from '@/components/parameters/form/expiration-time.vue';
import ParametersFormPatientClassification from '@/components/parameters/form/patient-classification.vue';
import ParametersFormProportionCalN from '@/components/parameters/form/proportion-cal-n.vue';
import ParametersFormSchedulingDays from '@/components/parameters/form/scheduling-days.vue';
import ParametersFormTranscriptionApprove from '@/components/parameters/form/transcription-approve.vue';
import ParametersFormTranscriptionMinChecks from '@/components/parameters/form/transcription-min-checks.vue';
import ParametersFormIndexacaoTemplate from '@/components/parameters/indexacao-template/list.vue';
import InfusionTime from '@/components/parameters/infusion-time/list.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { filterByText } from '@/helpers/filterByText';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import { IParameter } from '@/interfaces/parameters';
import ParameterModel from '@/models/parameter-model';
import * as service from '@/services/parameters';
import {
  BLOCKING_INACTIVE_ACCESS, CANCELLATION_REASON,
  CHAVE_CONSULTA_CFM, EXPIRATION_TIME,
  INDEXACAO_1,
  INDEXACAO_2,
  INDEXACAO_3,
  INDEXACAO_4, INFUSION_TIME,
  PARAMETERS_VALUE_TYPE_BOOLEAN,
  PARAMETERS_VALUE_TYPE_FILE,
  PARAMETERS_VALUE_TYPE_INTEGER, PARAMETERS_VALUE_TYPE_LIST_TEXT, PARAMETERS_VALUE_TYPE_PASSWORD, PARAMETERS_VALUE_TYPE_TEXT, PATIENT_CLASSIFICATION_PARAM,
  PROPORTION_CAL_N, SCHEDULING_DAYS,
  TEMPO_CANCEL_PROSPEC, TRANSCRIPTION_APPROVE_PARAM,
  TRANSCRIPTION_MIN_CHECKS
} from '@/settings/consts/parameters-keys';
import ParametersOverrides from '@/views/parameters/screens/overrides.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ParametersFormBooleanListType from '../form/boolean-list-type.vue';
import ParametersFormBooleanType from '../form/boolean-type.vue';
import ParametersFormFileType from '../form/file-type.vue';
import ParametersFormIntegerType from '../form/integer-type.vue';
import ParametersFormListTextType from '../form/list-text-type.vue';
import ParametersFormPasswordType from '../form/password-type.vue';
import ParametersFormTextType from '../form/text-type.vue';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    ParametersOverrides,
    ParametersFormPatientClassification,
    ParametersFormSchedulingDays,
    ParametersFormTranscriptionApprove,
    ParametersFormTranscriptionMinChecks,
    ParametersFormExpirationTime,
    ParametersFormProportionCalN,
    ParametersFormBlockingIanctiveAccess,
    InfusionTime,
    CancellationReasons,
    ParametersFormIndexacaoTemplate,
    ParametersFormBooleanType,
    ParametersFormBooleanListType,
    ParametersFormIntegerType,
    ParametersFormTextType,
    ParametersFormFileType,
    ParametersFormPasswordType,
    ParametersFormListTextType
  },
})
export default class ParametersParameterList extends BaseComponent {
  @Prop()
  public filter: any;

  public formOpen: boolean = false;
  public overridesListOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public selectedParameter: ParameterModel = new ParameterModel();

  public headers: any = [
    { text: 'Descrição', value: 'nome' },
    { text: 'Ações', value: 'name', sortable: false, align: 'right' },
  ];
  
  public data: ParameterModel[] = [];
  public item: ParameterModel = new ParameterModel();

  public parametersTypes: any = {
    schedulingDays: SCHEDULING_DAYS,
    transcriptionApprove: TRANSCRIPTION_APPROVE_PARAM,
    transcriptionMinChecks: TRANSCRIPTION_MIN_CHECKS,
    patientClassification: PATIENT_CLASSIFICATION_PARAM,
    cancelationReasons: CANCELLATION_REASON,
    expirationTime: EXPIRATION_TIME,
    infusionTime: INFUSION_TIME,
    proportionCalN: PROPORTION_CAL_N,
    indexacao_1: INDEXACAO_1,
    indexacao_2: INDEXACAO_2,
    indexacao_3: INDEXACAO_3,
    indexacao_4: INDEXACAO_4,
    blocking_inactive_access: BLOCKING_INACTIVE_ACCESS,
    tempoCancelProspec: TEMPO_CANCEL_PROSPEC,
    cfmConsultKey: CHAVE_CONSULTA_CFM,
  };

  public beforeMount(): void {
    this.load();
  }

  public load(): void {
    this.loading = true;
    this.error = false;
    service.getParameters().subscribe(
      (data) => {
        this.data = data.map((item) => new ParameterModel(item));
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = true;
      },
    );
  }

  private isParameterBooleanType() {
    return this.item && this.item.valores && this.item.valores.length == 1 && this.item.valores[0].tipoValorParametro == PARAMETERS_VALUE_TYPE_BOOLEAN;
  }

  private isParameterBooleanListType() {
    return this.item && this.item.valores && this.item.valores.length > 1 && this.item.valores[0].tipoValorParametro == PARAMETERS_VALUE_TYPE_BOOLEAN;
  }

  private isParameterIntegerType() {
    return this.item && this.item.valores && this.item.valores.length == 1 && this.item.valores[0].tipoValorParametro == PARAMETERS_VALUE_TYPE_INTEGER;
  }

  private isParameterTextType() {
    return this.item && this.item.valores && this.item.valores.length == 1 && this.item.valores[0].tipoValorParametro == PARAMETERS_VALUE_TYPE_TEXT;
  }

  private isParameterFileType() {
    return this.item && this.item.valores && this.item.valores.length == 1 && this.item.valores[0].tipoValorParametro == PARAMETERS_VALUE_TYPE_FILE;
  }

  private isParameterPasswordType() {
    return this.item && this.item.valores && this.item.valores.length == 1 && this.item.valores[0].tipoValorParametro == PARAMETERS_VALUE_TYPE_PASSWORD;
  }

  private isParameterTextListType() {
    return this.item && this.item.valores && 
      ( 
        ( this.item.valores.length > 1 && this.item.valores[0].tipoValorParametro == PARAMETERS_VALUE_TYPE_TEXT) 
        || 
        (this.item.valores.length > 0 && this.item.valores[0].tipoValorParametro == PARAMETERS_VALUE_TYPE_LIST_TEXT)
      );
  }

  public onEditItem(item: IParameter): void {
    this.item = new ParameterModel(item);
    this.formOpen = true;
  }

  public onCloseForm(): void {
    this.formOpen = false;
    this.item = new ParameterModel();
    this.load();
    resetModalScroll();
  }

  public onCloseOverridesClick(): void {
    this.overridesListOpen = false;
    this.selectedParameter = null;
  }

  public viewOverrides(item: ParameterModel): void {
    this.selectedParameter = item;
    this.overridesListOpen = true;
  }

  public showButtonOverride(item: ParameterModel): boolean {    
    return item.hierarquiasPossiveis.length > 1;
  }

  public customFilter(items, search, filter): any[] {
    const searchLower = search.toString().toLowerCase();
    return items.filter((row) => {
      return filterByText(row, ['nome'], searchLower);
    });
  }
}
